import instanceQuery from 'graphql/queries/product/StockTakeLineQuery.graphql';
import workspaceQuery from 'graphql/queries/product/StockTakeLineWorkspaceQuery.graphql';
import defaultQuery from 'graphql/queries/product/StockTakeLineDefault.graphql';
import listQuery from 'graphql/queries/product/StockTakeLineListQuery.graphql';
import fragment from 'graphql/fragments/product/StockTakeLineFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { IWorkspaceAction } from '../../../@types/workspaceTypes';
import { ReportType } from '../../schema/p4types';

export enum IStockTakeLineWorkspaceAction {
  StockTakeVarianceAddToPreview = 'STOCK_TAKE_VARIANCE_ADD_TO_PREVIEW',
  StockTakeVarianceReport = 'STOCK_TAKE_VARIANCE_REPORT',
}

export const workspaceActionsForPermissions: Array<IWorkspaceAction> = [
  { actionReference: IStockTakeLineWorkspaceAction.StockTakeVarianceAddToPreview },
  { actionReference: IStockTakeLineWorkspaceAction.StockTakeVarianceReport },
];

const StockTakeLine: EntityType = {
  type: 'StockTakeLine',
  title: 'Stock Take Line',
  formTitle: 'Stock Take Line',
  formUrl: '/Products/StockControl/StockTake/Details/',
  workspaceUrl: '/Products/StockControl/StockTakeLine/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  list: listQuery,
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_TAKE_PROGRESSIVE',
  actions: [...workspaceActionsForPermissions],
};

export default StockTakeLine;
